import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title,
  description,
  keywords,
  image = "/assets/images/CompanyLogo.jpg",
  url = "https://www.protodiag.com",
  type = "website",
}) => {
  const fullTitle = title
    ? `${title} | ProtoDiag Solutions`
    : "ProtoDiag Solutions | Enterprise Telecom Solutions & Communication Infrastructure";
  const fullDescription =
    description ||
    "ProtoDiag Solutions - Leading provider of enterprise-grade telecom solutions including Bulk Messaging Gateway, Voice Communications Platform, and SMS Firewall. Based in Noida, India.";
  const fullKeywords =
    keywords ||
    "ProtoDiag Solutions, telecom solutions, bulk messaging gateway, SMS gateway, voice communications, IVR platform, SMS firewall, telecom technology, Noida, India, enterprise communication, telecom infrastructure, messaging platform, call center solutions, telecom services";
  const fullImage = image.startsWith("http")
    ? image
    : `${url}${image.startsWith("/") ? "" : "/"}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="ProtoDiag Solutions" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
